"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cancelDefer = exports.defer = void 0;
function getRequestAnimationFrame() {
    return (window.requestAnimationFrame ||
        window.webkitRequestAnimationFrame ||
        window.mozRequestAnimationFrame);
}
function getCancelAnimationFrame() {
    return (window.cancelAnimationFrame ||
        window.webkitCancelRequestAnimationFrame ||
        window.webkitCancelAnimationFrame ||
        window.mozCancelAnimationFrame);
}
function defer(fn) {
    var hasCancelAnimationFrame = !!getCancelAnimationFrame();
    var deferFn;
    if (hasCancelAnimationFrame) {
        deferFn = getRequestAnimationFrame();
    }
    else {
        deferFn = function () { return setTimeout(fn, 1000 / 60); };
    }
    return deferFn(fn);
}
exports.defer = defer;
function cancelDefer(deferId) {
    var cancelFn = getCancelAnimationFrame() || clearTimeout;
    cancelFn(deferId);
}
exports.cancelDefer = cancelDefer;
